module.exports = __webpack_public_path__ + "img/fixed-bay.f45ed16.svg";